<div id="grid1ConfigDiv" class="grid-container">
  <!--Testata configurazione colonne-->
  <dx-data-grid
    id="gridConfigAction"
    [allowColumnResizing]="true"
    [dataSource]="gridConf.actions"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [showBorders]="false"
    [showColumnLines]="true"
    [showRowLines]="true"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowUpdated)="onConfigRowUpdating($event)"
    [height]="(windowSize.contentHeight ?? 0) - tabsHeight"
    (onToolbarPreparing)="hideButtons($event)"
    (onEditingStart)="saveData()"
  >
    <dxi-column dataField="id" [caption]="'Id' | siaTranslate"></dxi-column>
    <dxi-column
      dataField="cellTemplate"
      [caption]="'Template' | siaTranslate"
      alignment="center"
    >
      <dxo-lookup
        [dataSource]="gridConfTemplateTypes"
        displayExpr="name"
        valueExpr="id"
      >
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="cellTemplateParam"
      [caption]="'Parametro Editor o Template' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="onClick"
      [caption]="'Evento click' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="visibilityConditions"
      [caption]="'Condizioni di visibilità' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="visibilityScript"
      [caption]="'Script visibilità' | siaTranslate"
      alignment="left"
    >
    </dxi-column>
    <dxi-column
      dataField="buttonText"
      [caption]="'Testo pulsante' | siaTranslate"
      dataType="string"
      alignment="left"
    ></dxi-column>
    <dxi-column
      dataField="icon"
      [caption]="'Icona' | siaTranslate"
      dataType="string"
      alignment="left"
    ></dxi-column>
    <dxi-column
      dataField="visibleIndex"
      [caption]="'Ord.' | siaTranslate"
      dataType="number"
      alignment="center"
      sortOrder="asc"
      width="80px"
    ></dxi-column>
    <dxi-column
      dataField="width"
      [caption]="'Larghezza' | siaTranslate"
      width="60px"
      dataType="number"
    ></dxi-column>
    <dxi-column
      dataField="onlyAdmin"
      [caption]="'Solo admin' | siaTranslate"
      dataType="boolean"
      width="50px"
    ></dxi-column>

    <dxo-editing
      mode="batch"
      refreshMode="repaint"
      [allowUpdating]="true"
      [allowDeleting]="true"
      [allowAdding]="true"
      [selectTextOnEditStart]="selectTextOnEditStart"
      [startEditAction]="startEditAction"
    >
    </dxo-editing>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-remote-operations [sorting]="true" [paging]="true">
    </dxo-remote-operations>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
    <dxo-load-panel [enabled]="false"></dxo-load-panel>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-search-panel [visible]="false"></dxo-search-panel>
    <dxo-group-panel [visible]="false"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
  </dx-data-grid>
</div>
